<template>
  <router-view />
</template>

<script setup>
import {provide} from 'vue';
import {useRequiredUrls} from '@canopyllc/roots/composables/requiredUrls';

const props = defineProps({
  emailDomains: {
    type: Object,
    default: () => ({}),
  },
  urls: {
    type: Object,
    default: () => ({}),
  },
});

useRequiredUrls([
  'nextUrl',
  'signinUrl',
  'termsUrl',
  'privacyUrl',
  'signinApiUrl',
  'signoutApiUrl',
  'passwordResetRequestApiUrl',
  'passwordResetApiUrl',
]);

provide('emailDomains', props.emailDomains);
</script>